/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ForwarderPriceProvider,
  ForwarderPriceProviderInterface,
} from "../ForwarderPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetEqualToSource",
    type: "error",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "DoubleForwardingIsNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceSourceIsNotReady",
    type: "error",
  },
  {
    inputs: [],
    name: "RemovingAssetWhenRegisteredInRepository",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "priceSourceAsset",
        type: "address",
      },
    ],
    name: "AssetRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "AssetRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "priceSourceAssets",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "removeAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceSourceAsset",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ForwarderPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ForwarderPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ForwarderPriceProvider__factory extends ContractFactory {
  constructor(...args: ForwarderPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ForwarderPriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ForwarderPriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      overrides || {}
    ) as Promise<ForwarderPriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      overrides || {}
    );
  }
  attach(address: string): ForwarderPriceProvider {
    return super.attach(address) as ForwarderPriceProvider;
  }
  connect(signer: Signer): ForwarderPriceProvider__factory {
    return super.connect(signer) as ForwarderPriceProvider__factory;
  }
  static readonly contractName: "ForwarderPriceProvider";
  public readonly contractName: "ForwarderPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ForwarderPriceProviderInterface {
    return new utils.Interface(_abi) as ForwarderPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ForwarderPriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ForwarderPriceProvider;
  }
}
